import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_19: FaireProductEntity = {
  token: "sweet-wink-19",
  type: "product",
  name: "Heartbreaker Checkered Valentine's Day Sweatshirt - Boys",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/7f695b69085d399e84a343b4b90fbfcfddc7d0c3bd75e3368e01aa7d406fcce4.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1079,1079,x0,y0,safe&width=720",
  priceDollars: 20,
  msrpDollars: 40,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
